// Audit Kepatuhan PPI Rumah Sakit (RSPS/AUDIT-PPI/001).
// Label item tidak diduplikasi di sini — katalog diambil dari backend
// (GET ppi/audit-kepatuhan-ppi/catalog) agar single source of truth.

export interface SeksiMeta {
  huruf: string;
  label: string;
  metode: string;
  custom: boolean;
}

export const SEKSI_ORDER = [
  "apd",
  "intravaskuler",
  "kateter",
  "linen",
  "instrument",
  "reuse"
];

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const HASIL_OPTIONS = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check-bold" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close-thick" },
  { text: "N/A", value: "na", color: "grey", icon: "mdi-minus" }
];

// Legenda penanda metode audit (footer blanko).
export const METODE_LEGENDA =
  "O = Observasi · IP = Interview Personal · D = Dokumen";
